/**
 * Atributos de carga de una <img>, en un solo sitio.
 *
 * El navegador no sabe cual de las imagenes de la pagina esta mirando el
 * visitante, y las dos formas de no decirselo salen mal:
 *
 *  - `loading="lazy"` en todas aparca tambien la primera, que es la unica
 *    que se ve, y ademas le baja la prioridad. Es lo que hacia que la foto
 *    grande de la portada, la del primer articulo y la del primer concierto
 *    salieran en blanco mientras el texto de al lado ya estaba pintado.
 *  - sin ningun lazy, las dieciseis de una lista compiten entre si y la de
 *    arriba no gana: llega cuando le toca.
 *
 * La regla es la misma en todas partes: la primera de cada lista se pide ya
 * y con prioridad alta, y el resto espera a acercarse a la pantalla.
 *
 * `cargarYa` se pasa como `i === 0` en las listas y como "la galeria esta en
 * pantalla" en el carrusel, que son las dos formas de decir lo mismo: esta
 * imagen la esta mirando alguien ahora.
 */
/**
 * En una rejilla la primera fila entera se ve de entrada, asi que esas fotos
 * no deben esperar. Pero alta solo puede haber una: marcar cuatro como alta
 * es como no marcar ninguna. De ahi los dos parametros.
 */
export function atributosDeCarga(cargarYa: boolean, prioridadAlta: boolean = cargarYa) {
  return {
    loading: cargarYa ? ("eager" as const) : ("lazy" as const),
    fetchPriority: prioridadAlta ? ("high" as const) : ("auto" as const),
    decoding: "async" as const,
  };
}
